export default {"src":"/_next/static/media/cor1.dff81b39.svg","height":100,"width":99,"blurWidth":0,"blurHeight":0};